import { addRefreshAuthToDataProvider } from 'react-admin';
import { DataProvider } from "react-admin";
import { DashboardInfo } from "../models/dashboard";
import { msalHttpClient, msalRefreshAuth } from 'ra-auth-msal';
import { msalInstance } from '../auth/authProvider';
import { tokenRequest } from '../auth/authConfig';

// Using restDataProvider instead of simpleRestProvider to get compression enabled
import restDataProvider from './restDataProvider';
//import simpleRestProvider from 'ra-data-simple-rest'; 

export type EstateTimeDataProvider<ResourceType extends string = string> = DataProvider<ResourceType> & {
  getDashboardInfo: () => Promise<DashboardInfo>;
  getDashboardMarektEfficiency: () => Promise<any>;
  getDealsMonthly: () => Promise<any>;
  feedback: (data: any) => Promise<any>;
};

const apiUrl = import.meta.env.VITE_ESTATE_TIME_SERVICE_URL! as string;

const httpAuthClient = msalHttpClient({
  msalInstance: msalInstance,
  tokenRequest,
});

const authDataProvider = addRefreshAuthToDataProvider(
  restDataProvider(apiUrl, httpAuthClient),
  msalRefreshAuth({
    msalInstance: msalInstance,
    tokenRequest,
  })
);

const httpClient = (url: string, options?: any) => httpAuthClient(
  `${apiUrl}/${url}`, options).then(({ json } : { json: any }) => (json));

export const estateDataProvider: EstateTimeDataProvider = {
  ...authDataProvider,
  getDashboardInfo: () => httpClient(`dashboard/info`),
  getDashboardMarektEfficiency: () => httpClient(`dashboard/market-efficiency`),
  getDealsMonthly: () => httpClient(`dashboard/deals-monthly`),
  feedback: (data: any) => httpClient(`feedback`, {
    method: 'POST',
    body: JSON.stringify(data),
  }),
};
